import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    maxWidth: "20rem",
    position: "relative",
    backgroundColor: theme.palette.tour.background,
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "1rem",
  },
}));
